export default __webpack_public_path__ + "6a61cbee4829b91bc55c8865962c1c13.png";